import { ng } from '@uirouter/angularjs/lib/angular';
import angular = require('angular');
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { IngredientsService } from '../../../common/services/ingredients.service';
import { IIngredient } from '../../../model/ingredients/IIngredient';

class IngredientDialog implements ng.IController {
    public static $inject = [
        '$translate',
        'notificationService',
        'ingredientsService'
    ];
    public modalInstance: ng.ui.bootstrap.IModalInstanceService = this as any;
    public waiting: boolean;
    public resolve: { ingredient: IIngredient };

    public item: IIngredient = {
        Archived: null,
        ID: null,
        Title: null
    } as IIngredient;

    public isNew: boolean = true;
    public showUniqueNameError: boolean = false;
    public showLongNameError: boolean = false;

    private MAX_NAME_LENGTH: number = 64;

    constructor(
        private $translate: angular.translate.ITranslateService,
        private notificationService: NotificationService,
        private ingredientsService: IngredientsService
    ) {}

    public async $onInit() {
        if (this.resolve.ingredient) {
            this.item = {
                Archived: this.resolve.ingredient.Archived,
                ID: this.resolve.ingredient.ID,
                Title: this.resolve.ingredient.Title
            } as IIngredient;
        }
        this.isNew = !this.resolve.ingredient;
    }

    public async titleChange() {
        this.showUniqueNameError = false;
        this.showLongNameError = false;
    }

    public async updateIngredient() {

        if (this.isLongName() ) {
            this.showLongNameError = true;
            return;
        }

        const isIngredientUnique = await this.isIngredientUnique();

        if (!isIngredientUnique) {
            this.showUniqueNameError = true;
            return;
        }

        try {
            this.waiting = true;
            if (this.isNew) {
                await this.ingredientsService.addIngredient(this.item.Title);
            } else {
                await this.ingredientsService.editIngredient(this.resolve.ingredient.ID, this.item.Title);
            }
            this.modalInstance.close({ $value: { status: 'ok'}});
        } catch (e) {
            this.notificationService.showErrorMessage(e);
        } finally {
            this.waiting = false;
            this.notificationService.clearAll();
        }
    }

    public closeDialog() {
        this.modalInstance.dismiss({ $value: { status: 'cancel'} });
    }

    private isLongName() {
        return this.item.Title.length > this.MAX_NAME_LENGTH;
    }

    private async isIngredientUnique() {
        try {
            this.waiting = true;
            await this.ingredientsService.checkTitleForExist(this.item.Title, this.isNew ? null : this.item.ID);
            return true;
        } catch (e) {
            return false;
        } finally {
            this.waiting = false;
        }
    }
}

angular.module('naut').component('ingredientDialog', {
    template: require('./ingredient-dialog.component.html'),
    controller: IngredientDialog,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/ingredients/tabs-list/ingredient-dialog/ingredient-dialog.component.ts